import React from 'react'

export function SuspenseLoader() {
  return (
    <div style={{
      position: 'fixed',
      top: 0, left: 0,
      width: '100vw', height: '100vh',
      display: 'flex', flexDirection: 'column',
      justifyContent: 'center', alignItems: 'center',
      background: '#f5f7f9',
      zIndex: 2000,
    }}>
      <img
        src={`${process.env.PUBLIC_URL}/images/ViZmeraldLoader.svg`}
        alt="ViZmerald loading"
        style={{
          width: '120px', height: '120px',
          marginBottom: '20px',
          animation: 'pulse 1.5s infinite ease-in-out'
        }}
      />
      <p style={{
        fontSize: '12px', opacity: 0.5,
        textTransform: 'uppercase', letterSpacing: '2px'
      }}>
        Chargement...
      </p>
    </div>
  )
}
